import { subscriptionsApi } from 'api'
import { GlobalError, ProcessingKey } from 'constants/rootConstants'
import { sendRetenoCustomerData } from 'helpers/sendRetenoCustomerData'
import { eventLogger } from 'services/eventLogger.service'
import type { ILeadRaw } from 'src/models/lead.model'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const updateLeadWithEmail = async ({
  email,
  successCallback,
  unsuccessfulCallback,
}: {
  email: string
  successCallback?: () => void
  unsuccessfulCallback?: () => void
}): Promise<void> => {
  useZustandStore
    .getState()
    .startProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)

  const leadId = useZustandStore.getState().lead?.id || ''
  const cohort =
    useZustandStore.getState().lead?.cohort ||
    useZustandStore.getState().initialCohort

  const updateResponse = await subscriptionsApi.updateLead(leadId, { email })

  if (!updateResponse.success) {
    useZustandStore.setState({ globalError: GlobalError.COMMON_ERROR })

    eventLogger.logEmailPageError({
      error: JSON.stringify(updateResponse.data),
    })

    if (unsuccessfulCallback) {
      unsuccessfulCallback()
    }
    useZustandStore
      .getState()
      .stopProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)
    return
  }

  sendRetenoCustomerData(email)

  if (successCallback) {
    successCallback()
  }

  // Getting updated lead should not block success callback returning
  const updatedLeadResponse = await subscriptionsApi.getLead({ leadId, cohort })
  const lead: ILeadRaw = updatedLeadResponse.data

  useZustandStore.setState({ lead })
  useZustandGlobalLocalStore.setState((state) => ({
    previousLeadId: state.previousLeadId || lead.id,
  }))

  useZustandStore
    .getState()
    .stopProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)
}
